module.exports = __webpack_public_path__ + "static/img/app_store.c008826.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/app_store.png
// module id = 340
// module chunks = 6